import React from 'react';
import { Box, Group, Title, Text, useMantineColorScheme } from '@mantine/core';

interface PageHeaderProps {
  title: string;
  subtitle?: React.ReactNode;
  /** Acciones a la derecha del header (botones, buscador, etc.) */
  rightSection?: React.ReactNode;
}

/**
 * Cabecera de página estándar de la app: título en Space Grotesk + subtítulo
 * tenue, alineados a la izquierda, con un espacio opcional para acciones a la
 * derecha. Misma estética que el resto de páginas (Rankings, Notificaciones…).
 */
const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, rightSection }) => {
  const { colorScheme } = useMantineColorScheme();

  return (
    <Group justify="space-between" align="center" wrap="wrap" gap="sm">
      <Box>
        <Title
          order={2}
          size="1.3rem"
          fw={600}
          ta="left"
          style={{
            color: colorScheme === 'dark' ? '#e2e8f0' : '#1e293b',
            fontFamily: 'Space Grotesk, Inter, sans-serif',
            marginBottom: '4px',
          }}
        >
          {title}
        </Title>
        {subtitle && (
          <Text
            size="xs"
            ta="left"
            style={{
              color: colorScheme === 'dark' ? '#94a3b8' : '#64748b',
              fontFamily: 'Inter, sans-serif',
            }}
          >
            {subtitle}
          </Text>
        )}
      </Box>
      {rightSection}
    </Group>
  );
};

export default PageHeader;
